// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.install-app-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 1rem;
  padding: 14px 18px;
  border: none;
  border-radius: 12px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}

.profile-complete .install-app-cta {
  margin-top: 1.25rem;
}

.profile-complete .next-button {
  width: 100%;
  margin-top: 0.75rem;
  background: transparent;
  color: var(--brand-primary, #0877bc);
  border: 2px solid color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);
  box-shadow: none;
}

.profile-complete .next-button:hover {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);
  box-shadow: none;
}

.install-app-cta:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

.install-app-cta:disabled {
  opacity: 0.7;
  cursor: wait;
}

.install-app-cta__hint {
  margin: 0.55rem 0 0;
  font-size: 0.85rem;
  line-height: 1.35;
  color: var(--text-secondary, #6b7280);
  text-align: center;
}

.install-app-row .install-app-row__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.install-app-row .install-app-row__text p {
  margin: 0;
}

.install-app-row__hint {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  color: var(--text-secondary, #6b7280);
}

.install-app-row--ready .install-app-row__hint,
.install-app-cta--ready + .install-app-cta__hint {
  color: var(--brand-primary, #0877bc);
  font-weight: 600;
}

.install-app-row--done {
  cursor: default;
  opacity: 0.85;
}

.ios-setting-icon-badge.install {
  background: linear-gradient(135deg, #0877bc, #0ea5e9);
  color: #fff;
}

.install-app-dialog__paper {
  border-radius: 16px !important;
  padding: 0;
  overflow: hidden;
}

.install-app-dialog__body {
  padding: 1.35rem 1.25rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.install-app-dialog__body h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 750;
}

.install-app-dialog__steps {
  margin: 0;
  padding-left: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  font-size: 0.95rem;
  line-height: 1.4;
  color: var(--text-secondary, #374151);
}

.install-app-dialog__close {
  margin-top: 0.35rem;
  align-self: stretch;
  padding: 12px 16px;
  border: none;
  border-radius: 12px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/InstallAppButton.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yFAAyF;AAC3F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".install-app-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  margin-top: 1rem;\n  padding: 14px 18px;\n  border: none;\n  border-radius: 12px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n\n.profile-complete .install-app-cta {\n  margin-top: 1.25rem;\n}\n\n.profile-complete .next-button {\n  width: 100%;\n  margin-top: 0.75rem;\n  background: transparent;\n  color: var(--brand-primary, #0877bc);\n  border: 2px solid color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);\n  box-shadow: none;\n}\n\n.profile-complete .next-button:hover {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);\n  box-shadow: none;\n}\n\n.install-app-cta:hover:not(:disabled) {\n  filter: brightness(1.05);\n  transform: translateY(-1px);\n}\n\n.install-app-cta:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.install-app-cta__hint {\n  margin: 0.55rem 0 0;\n  font-size: 0.85rem;\n  line-height: 1.35;\n  color: var(--text-secondary, #6b7280);\n  text-align: center;\n}\n\n.install-app-row .install-app-row__text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-width: 0;\n}\n\n.install-app-row .install-app-row__text p {\n  margin: 0;\n}\n\n.install-app-row__hint {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: var(--text-secondary, #6b7280);\n}\n\n.install-app-row--ready .install-app-row__hint,\n.install-app-cta--ready + .install-app-cta__hint {\n  color: var(--brand-primary, #0877bc);\n  font-weight: 600;\n}\n\n.install-app-row--done {\n  cursor: default;\n  opacity: 0.85;\n}\n\n.ios-setting-icon-badge.install {\n  background: linear-gradient(135deg, #0877bc, #0ea5e9);\n  color: #fff;\n}\n\n.install-app-dialog__paper {\n  border-radius: 16px !important;\n  padding: 0;\n  overflow: hidden;\n}\n\n.install-app-dialog__body {\n  padding: 1.35rem 1.25rem 1.15rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.install-app-dialog__body h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 750;\n}\n\n.install-app-dialog__steps {\n  margin: 0;\n  padding-left: 1.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  color: var(--text-secondary, #374151);\n}\n\n.install-app-dialog__close {\n  margin-top: 0.35rem;\n  align-self: stretch;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 12px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
